import { collection, getDocs, getDoc } from "firebase/firestore";
import { dbAML as db } from "../../../../backend/firebaseConfig";

/**
 * Fetch the latest Experian Response doc (same path as your live subscriber)
 * AML Checks/{ownerEmail}/Checks/{checkId}/Experian Response/{doc}
 */
export async function fetchExperianResponseLatest(ownerEmail, checkId) {
  if (!ownerEmail || !checkId) throw new Error("Missing ownerEmail/checkId");

  const path = `AML Checks/${ownerEmail}/Checks/${checkId}/Experian Response`;
  const colRef = collection(db, path);

  const snap = await getDocs(colRef);
  if (snap.empty) return null;

  // You currently use "first doc" everywhere — keep consistent
  const docRef = snap.docs[0].ref;


  const docSnap = await getDoc(docRef);
  // console.log("fetchExperianResponseLatest:", { ownerEmail, checkId, docSnapData: docSnap.data() });
  return docSnap.exists() ? docSnap.data().response : null;
}
